import { doConfirmCurrentUser } from 'ducks/currentUser/operations'
import { mapErrorsToFormFields } from 'api/graphql'
import { doFinishOnboarding } from '../actions'

export function doSaveAndRedirect({ confirmationToken }) {
  return dispatch => {
    return dispatch(doConfirmCurrentUser(confirmationToken))
      .then(() => {
        return dispatch(doFinishOnboarding())
      })
      .catch(mapErrorsToFormFields)
  }
}
